"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var modalPaperStyles = makeStyles_1.default(function (theme) {
    var _a, _b;
    return ({
        closeButton: {
            '&:not(:disabled)': (_a = {
                    zIndex: 1000,
                    position: 'absolute',
                    padding: 0,
                    '&:hover': {
                        background: 'transparent',
                    }
                },
                _a[theme.breakpoints.down('sm')] = {
                    transform: 'scale(0.88)',
                    top: 5,
                    right: 5,
                },
                _a[theme.breakpoints.up('md')] = {
                    transform: 'scale(1.3)',
                    top: 0,
                    right: -40,
                    color: theme.palette.common.white,
                },
                _a),
        },
        closeIcon: {
            width: 40,
            height: 40,
            fill: theme.palette.primary.main,
        },
        overlayPaper: (_b = {
                width: 750,
                overflow: 'visible',
                margin: '48px'
            },
            _b[theme.breakpoints.down('sm')] = {
                margin: 0,
            },
            _b),
        insetPaper: {
            margin: 0,
            boxShadow: 'none',
        },
    });
}, { name: 'Checkout_ModalPaper' });
exports.default = modalPaperStyles;
